import React from "react";

/**
 * HEYHOMECAN Logo — SVG reconstruction of the yellow-square monogram
 * described in the brand PDF (double H + house silhouette + open C).
 * Two variants:
 *   - "badge"  : yellow tile with monogram + wordmark below
 *   - "inline" : compact horizontal (tile + wordmark) for header/footer
 */
export const Logo = ({ variant = "inline", className = "" }) => {
    if (variant === "badge") {
        return (
            <div
                className={`inline-flex flex-col items-center ${className}`}
                data-testid="brand-logo-badge"
            >
                <LogoTile size={128} />
                <div className="mt-4 text-center">
                    <div className="font-display text-[22px] tracking-[0.14em] text-hhc-ink font-semibold">
                        HEYHOMECAN
                    </div>
                    <div className="text-[10px] tracking-[0.32em] text-hhc-muted mt-1 uppercase">
                        design · build · renovate
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div
            className={`inline-flex items-center gap-3 ${className}`}
            data-testid="brand-logo"
        >
            <LogoTile size={40} />
            <div className="flex flex-col leading-none">
                <span className="font-display text-[17px] tracking-[0.14em] text-hhc-ink font-semibold">
                    HEYHOMECAN
                </span>
                <span className="text-[9px] tracking-[0.3em] text-hhc-muted uppercase mt-1">
                    design · build · renovate
                </span>
            </div>
        </div>
    );
};

export const LogoTile = ({ size = 40 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 100 100"
        role="img"
        aria-label="HEYHOMECAN"
    >
        <rect width="100" height="100" rx="14" fill="#F3C948" />
        {/* Left H — solid bars */}
        <rect x="18" y="26" width="6" height="48" fill="#1F2321" />
        <rect x="30" y="26" width="6" height="48" fill="#1F2321" />
        <rect x="18" y="47" width="18" height="6" fill="#1F2321" />
        {/* Right H shaped as house — roof + walls + door */}
        <polygon points="46,32 66,20 66,32" fill="#1F2321" />
        <rect x="46" y="32" width="4" height="42" fill="#1F2321" />
        <rect x="62" y="32" width="4" height="42" fill="#1F2321" />
        <rect x="46" y="50" width="20" height="4" fill="#1F2321" />
        <rect x="54" y="58" width="4" height="16" fill="#1F2321" />
        {/* Open C hugging the right side */}
        <path
            d="M84 34 A20 20 0 1 0 84 66"
            stroke="#6E6E6E"
            strokeWidth="6"
            fill="none"
            strokeLinecap="round"
        />
    </svg>
);

export default Logo;
